import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  timezone: {
    color: theme.palette.secondary.light,
    display: 'block',
  },
}));

export { useStyles };
